const gamez_data = {
    // Gamez
    'baloonschall': { code: 'BC' },
    'memoset': { code: 'MS' },
    'mentalabacusfixation': { code: 'MA' },
    'mentalsumsubstraction': { code: 'MSS' },
    'multiplydivide': { code: 'MD' },
    'pathchall': { code: 'PC' },
    'quantitygame': { code: 'QG' },
    'representinabacus': { code: 'RA' },
    'sumsubstractionnumber': { code: 'SS' },
    'sumsubstractionseries': { code: 'SSS' },
    'theory': { code: 'T' },
    'whatnumberis': { code: 'WN' },
    'cartoonlayout': { code: 'CL' },
    'coupleschall': { code: 'CC' },
    'guidedsequence': { code: 'GS' },
    'mentalcalculus': { code: 'MC', creation_date: '2025-04-20' },
    // Challenges
    'equationchallenge': { code: 'EC' },
    'numericpath': { code: 'NP' },
    'memomeshchallenge': { code: 'MMC' },
    'completeoperations': { code: 'CO' },
    'numberriddle': { code: 'NR' },
};

export default gamez_data;